import { Button, Icon } from "@/components"
import { rem } from "@mantine/core"
import SegueLink from "app/static/frontend/middleware/SegueLink"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import { editActionConnection } from "sheets/components/cells/action-buttons/selectors"

export const UnconnectedSegueLinkAction = ({
    type,
    icon,
    text,
    segueLinkPath,
    disabled,
    className,
    title,
    variant = "ghost",
}) => {
    return (
        <SegueLink className={className} to={segueLinkPath}>
            <Button
                variant={variant}
                leftIcon={<Icon icon={icon} />}
                size="xs"
                leftIconSize={rem(15)}
                title={title}
                disabled={disabled}
            >
                {text}
            </Button>
        </SegueLink>
    )
}

UnconnectedSegueLinkAction.propTypes = {
    disabled: PropTypes.bool,
    fields: PropTypes.object.isRequired,
    icon: PropTypes.string,
    segueLinkPath: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    title: PropTypes.string,
    type: PropTypes.string,
    variant: PropTypes.string,
}

export default connect(editActionConnection)(UnconnectedSegueLinkAction)
